import { createBrowserRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import App from "../App";
import Home from "./Home";
import AllCourses from "../pages/AllCourses";
import AllInstructors from "../pages/AllInstructors";
import CertificateVerification from "../pages/CertificateVerification";
import InstructorLogin from "../pages/InstructorLogin";
import InstructorPanel from "../pages/InstructorPanel";
import InstructorDashboard from "../pages/InstructorDashboard";
import InstructorMobileVerification from "../pages/InstructorMobileVerification";
import InstructorSignup from "../pages/InstructorSignup";
import InstructorOtp from "../pages/InstructorOtp";
import InstructorAccessDenied from "../pages/InstructorAccessDenied";
import InstructorProtectedRoute from "../pages/InstructorProtectedRoute";
import InstructorCourses from "../pages/InstructorCourses";
import InstructorProfile from "../pages/InstructorProfile";
import AddInstructorCourseSchedule from "../pages/AddInstructorCourseSchedule";
import Resourses from "../pages/Resourses";
import StudentLogin from "../student/StudentLogin";
import StudentPanel from "../student/StudentPanel";
import StudentDashboard from "../student/StudentDashboard";
import StudentCategorySelection from "../student/StudentCategorySelection";
import InstructorCourseschedule from "../pages/InstructorCourseschedule";
import StudentCourseSelection from "../student/StudentCourseSelection";
import StudentInstructorSelection from "../student/StudentInstructorSelection";
import StudentSelectedCourseDetails from "../student/StudentSelectedCourseDetails";
import StudentAllSet from "../student/StudentAllSet";
import StartLearning from "../student/StartLearning";
import StudentMobileVerifcation from "../student/StudentMobileVerifcation";
import StudentOtp from "../student/StudentOtp";
import StudentProfile from "../student/StudentProfile";
import CourseDetails from "../pages/CourseDetails";
import Adminpanel from "../adminpanel/AdminPanel";
import AdminLogin from "../adminpanel/AdminLogin";
import Dashboard from "../adminpanel/Dashboard";
import StudentList from "../adminpanel/StudentList";
import CreateInstructorForm from "../adminpanel/CreateInstructorForm";
import InstructorList from "../adminpanel/InstructorList";
import CollegeManagement from "../adminpanel/CollegeManagement";
import CollegesList from "../adminpanel/CollegesList";
import UploadStudentExcel from "../adminpanel/UploadExcel";
import CategoryManagement from "../adminpanel/CategoryManagement";
import CourseList from "../adminpanel/CourseList";
import CourseManagement from "../adminpanel/CourseManagement";
import createCourse from "../adminpanel/CreateCourse";
import AdminStudentDashboard from "../adminpanel/AdminStudentDashboard";
import AdminInstructorDashboard from "../adminpanel/AdminInstructorDashboard";
import TrendingCourses from "../pages/TrendingCourses";
import CarrerCourses from "../pages/CarrerCourses";
import CreateCourse from "../adminpanel/CreateCourse";
import AdminCourseDetails from "../adminpanel/AdminCourseDetails";
import StudentCreate from "../student/StudentCreate";
import StudentEnrolledCourses from "../student/StudentEnrolledCourses";
import EditProfile from "../pages/EditProfile";
import InstructorStudentReports from "../pages/InstructorStudentReports";
import AssignmentsInstructor from "../pages/AssignmentsInstructor";
import StudentCourseCurriculum from "../student/StudentCourseCurriculum";
import StudentCreateAdmin from "../adminpanel/StudentCreateAdmin";
import SAvedCourses from "../student/SAvedCourses";
import CreateBlog from "../adminpanel/CreateBlog";
import BlogReport from "../adminpanel/BlogReport";
import Allblogs from "../pages/Allblogs";
import BlogDetails from "../pages/BlogDetails";
import StudentProfileEdit from "../student/StudentProfileEdit";
import InstructorCurriculum from "../pages/InstructorCurriculum";
import InstructorForgotPassword from "../pages/InstructorForgotPassword";
import StudentPasswordOtp from "../student/StudentPasswordOtp";
import StudentResetPassword from "../student/StudentResetPassword";
import CourseCurriculum from "../pages/CourseCurriculum";
import Assignmentstudent from "../student/Assignmentstudent";

import InstructorDetails from "../pages/InstructorDetails";
import Announcements from "../student/Announcements";
import StudentExam from "../student/StudentExam";
import StudentCetificates from "../student/StudentCetificates";
import StudentProjects from "../student/StudentProjects";
import StudentPurchases from "../student/StudentPurchases";

import ThemeSwitcher from "../student/ThemeSwitcher";
import DegreeCourses from "../pages/DegreeCourses";
import UserInstructorDetails from "../pages/UserInstructorDetails";
import Contact from "../pages/Contact";
import About from "../pages/About";


const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!sessionStorage.getItem("adminData") &&
      !!sessionStorage.getItem("adminUser")
  );

  useEffect(() => {
    const checkAuth = () => {
      const adminData = sessionStorage.getItem("adminData");
      const adminUser = sessionStorage.getItem("adminUser");

      if (!adminData || !adminUser) {
        // Preserve the intended URL for redirect after login
        const redirectTo = encodeURIComponent(
          location.pathname + location.search
        );
        navigate(`/admin-panel/admin-login?redirect=${redirectTo}`);
      } else {
        setIsAuthenticated(true);
      }
    };
    checkAuth();
  }, [navigate, location.pathname, location.search]);

  return isAuthenticated ? children : null;
};
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <Home /> },
      {
        path: "/instructor-panel",
        element: <InstructorProtectedRoute />, // protects the routes
        children: [
          {
            path: "",
            element: <InstructorPanel />, // this renders sidebar and header
            children: [
              { path: "dashboard", element: <InstructorDashboard /> },
              { path: "instructor-courses", element: <InstructorCourses /> },
              {
                path: "addCourseSchedule",
                element: <AddInstructorCourseSchedule />,
              },
              { path: "instructor-profile", element: <InstructorProfile /> },
              { path: "edit-instructor", element: <EditProfile /> },
              // {
              //   path: "assignments-instructor",
              //   element: <AssignmentsInstructor />,
              // },
              {
                path: "instructorCourseSchedule",
                element: <InstructorCourseschedule />,
              },
              { path: "curriculum/:id", element: <InstructorCurriculum /> },
                { path: "course-curriculum/:id", element: <CourseCurriculum /> },

    {
            path: "instructor-details/:id",
            element: <InstructorDetails />,
          },
        { 
          path: "student-reports", 
          element: <InstructorStudentReports /> 
        },


            ],
          },
        ],
      },

      {
        path: "/admin-panel",
        element: (
          <AuthWrapper>
            <Adminpanel />
          </AuthWrapper>
        ),
        children: [
          { path: "", element: <Dashboard /> },
          { path: "dashboard", element: <Dashboard /> },
          { path: "Admin-student-create", element: <StudentCreateAdmin /> },
          { path: "student-list", element: <StudentList /> },
          { path: "create-instructor", element: <CreateInstructorForm /> },
          {
            path: "instructor-list",
            element: <InstructorList />,
          },
          {
            path: "college-management",
            element: <CollegeManagement />,
          },
          {
            path: "college-list",
            element: <CollegesList />,
          },
          {
            path: "excel-upload",
            element: <UploadStudentExcel />,
          },
          { path: "category-creation", element: <CategoryManagement /> },
          { path: "course-details", element: <AdminCourseDetails /> },
          {
            path: "course-list",
            element: <CourseList />,
          },

          {
            path: "course-creation",
            element: <CourseManagement />,
          },
          
          {
            path: "create-course",
            element: <CreateCourse />,
          },
          { path: "student-dashboard", element: <AdminStudentDashboard /> },

          { path: "instructor-details", element: <AdminInstructorDashboard /> },
          { path: "create-blog", element: <CreateBlog /> },
          { path: "blog-report", element: <BlogReport /> },
        ],
      },

      {
        path: "/student-panel",
        element: <StudentPanel />,
        children: [
          { path: "", element: <StudentDashboard /> },
          { path: "student-dashboard", element: <StudentDashboard /> },

          { path: "category-selection", element: <StudentCategorySelection /> },
          { path: "course-selection", element: <StudentCourseSelection /> },
          {
            path: "instructor-selection",
            element: <StudentInstructorSelection />,
          },
          {
            path: "selected-course-details",
            element: <StudentSelectedCourseDetails />,
          },
          {
            path: "course-all-set",
            element: <StudentAllSet />,
          },
          {
            path: "start-learning",
            element: <StartLearning />,
          },
          {
            path: "profile",
            element: <StudentProfile />,
          },
          {
            path: "courses",
            element: <StudentEnrolledCourses />,
          },
          {
            path: "course-curriculum/:id",
            element: <StudentCourseCurriculum />,
          },
          {
            path: "saved-courses",
            element: <SAvedCourses />,
          },
          {
            path: "edit-student",
            element: <StudentProfileEdit />,
          },


     {
            path: "assignment-student/:assignmentId",
            element: <Assignmentstudent />,
          },





     {
            path: "announcements",
            element: <Announcements />,
          },




     {
            path: "exams",
            element: <StudentExam />,
          },

    {
            path: "certificates",
            element: <StudentCetificates />,
          },
    {
            path: "projects",
            element: <StudentProjects />,
          },



    {
            path: "purchases",
            element: <StudentPurchases/>,
          },

          
        { 
          path: "settings", 
          element: <ThemeSwitcher /> 
        },


        ],
      },
      {
        path: "/admin-panel/admin-login",
        element: <AdminLogin />,
      },
      { path: "/student-login", element: <StudentLogin /> },
      { path: "/student-create", element: <StudentCreate /> },
      {
        path: "/student-verification",
        element: <StudentMobileVerifcation />,
      },
      { path: "/student-otp", element: <StudentOtp /> },
      { path: "/student-password-otp", element: <StudentPasswordOtp/> },
      { path: "/instructor-login", element: <InstructorLogin /> },
      {
        path: "/instructor-verification",
        element: <InstructorMobileVerification />,
      },
      {
        path: "/instructor-otp",
        element: <InstructorOtp />,
      },
      {
        path: "/instructor-signup",
        element: <InstructorSignup />,
      },
      {
        path: "/instructor-access-denied",
        element: <InstructorAccessDenied />,
      },
      { path: "all-courses", element: <AllCourses /> },
      { path: "all-courses/:id", element: <CourseDetails /> },
      { path: "trendy-courses", element: <TrendingCourses /> },
      { path: "carrer-courses", element: <CarrerCourses /> },
      { path: "all-instructors", element: <AllInstructors /> },
      { path: "resourses", element: <Resourses /> },
      {
        path: "Certificate-Verification",
        element: <CertificateVerification />,
      },
      {
        path: "/all-blogs",
        element: <Allblogs />,
      },
      { path: "blog-details/:id", element: <BlogDetails /> },
      {
        path: "instructor-forgot-password",
        element: <InstructorForgotPassword />,
      },
      {
        path: "student-reset-password",
        element: <StudentResetPassword/>
      },

{
        path: "degree-courses",
        element: <DegreeCourses/>
      },


{ path: "user-instructor", element: <UserInstructorDetails /> },



{ path: "user-instructor", element: <UserInstructorDetails /> },



{ path: "about", element: <About /> },
{ path: "contact", element: <Contact /> },



    ],
  },
]);

export default router;